export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-8 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-primary-600 via-primary-500 to-accent-600">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 right-0 w-96 h-96 rounded-full bg-white/20 blur-3xl translate-x-1/3 -translate-y-1/3"></div>
            <div className="absolute bottom-0 left-0 w-80 h-80 rounded-full bg-white/20 blur-3xl -translate-x-1/3 translate-y-1/3"></div>
          </div>

          <div className="relative flex flex-col lg:flex-row items-center gap-8 p-8 md:p-12 lg:p-14">
            <div className="flex-1 w-full text-white">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/15 backdrop-blur-sm mb-4">
                <i className="ri-smartphone-line text-sm"></i>
                <span className="text-xs font-medium whitespace-nowrap">移动端观影</span>
              </div>

              <h2 className="text-2xl md:text-3xl font-heading font-bold mb-3">
                随时随地 · 掌上看大片
              </h2>

              <p className="text-sm md:text-base text-white/75 leading-relaxed mb-6 max-w-lg">
                成全影视全面适配手机、平板等移动设备，无论在家还是出行途中，打开浏览器即可享受流畅高清的追剧体验。无需下载APP，不占内存，PWA技术支持离线缓存，地铁通勤也能追你爱的剧。
              </p>

              <div className="flex flex-wrap gap-3">
                {['免安装即用', '流量节省模式', '夜间护眼', '断点续播', '弹幕互动'].map((feat) => (
                  <span key={feat} className="px-3 py-1.5 rounded-lg bg-white/10 text-white/85 text-xs font-medium whitespace-nowrap">
                    <i className="ri-check-line mr-1"></i>{feat}
                  </span>
                ))}
              </div>
            </div>

            <div className="flex-shrink-0">
              <div className="relative w-[200px] h-[400px] md:w-[220px] md:h-[440px] rounded-[2rem] border-4 border-white/20 overflow-hidden shadow-2xl bg-black">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20smartphone%20screen%20displaying%20a%20modern%20video%20streaming%20interface%20with%20movie%20thumbnails%20grid%2C%20warm%20dark%20theme%2C%20cinematic%20UI%20design%2C%20clean%20layout%2C%20no%20text%2C%20app%20style&width=440&height=880&seq=app-mobile-screen&orientation=portrait"
                  alt="成全影视移动端界面"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}